import React from 'react';
import Header from './Header';
import Footer from './Footer';

/**
 * MainLayout 컴포넌트
 * Header + Content + Footer 구조를 제공하는 메인 레이아웃
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - 메인 콘텐츠
 */
const MainLayout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout;
